import { IPermissionEdit } from "./IPermissionEdit";

export class PermissionLobby {
  public selectAllPermissionLobby!: IPermissionEdit;

  public General!: {
    selectAll: boolean;
    editLobby: IPermissionEdit;
    viewCentralViews: IPermissionEdit;
    forceSignOutUsers: IPermissionEdit;
    accessAllQueues: IPermissionEdit;
  };

  public Checklist!: {
    selectAll: boolean;
    viewChecklist: IPermissionEdit;
    addChecklist: IPermissionEdit;
    editCheckList: IPermissionEdit;
    deleteChecklist: IPermissionEdit;
  };

  public Lwa!: {
    selectAll: boolean;

    lwaView: IPermissionEdit;
    lwaAdd: IPermissionEdit;
    lwaEdit: IPermissionEdit;
    lwaDelete: IPermissionEdit;
  };

  public TextConfiguration!: {
    selectAll: boolean;
    textConfigView: IPermissionEdit;
    textConfigEdit: IPermissionEdit;
    textConfigEnable: IPermissionEdit;
  };
}
